import { Container, Form, Button, Col, Row, Table } from 'react-bootstrap';
import { useState } from 'react';
import axios from 'axios';
import { root_url } from '../setting';

const UntactRank = () => {
  const [info, setInfo] = useState({});
  const [result, setResult] = useState([]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(info);
    if (!info.ticketName || !info.gender) {
      alert("선택을 완료해주세요");
      return;
    }
    // alert('순위가 확정되지 않았습니다.');
    console.log('clicked');
    try {
      let response = await axios.post(`${root_url}/api/untact/rank`, info);
      setResult(response.data);
      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Container>
      <h1 className="mt-3 mb-5">언택트 순위</h1>
      <Form inline onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col>
            <Form.Control
              as="select"
              onChange={(e) => {
                let ticketName = e.target.value;
                setInfo({ ...info, ticketName: ticketName });
              }}
            >
              <option value="">종목</option>
              <option value="10Km">10Km</option>
              <option value="18Km">18Km</option>
            </Form.Control>
          </Col>

          <Col>
            <Form.Control
              as="select"
              className="my-1 mr-sm-2"
              id="inlineFormCustomSelectPref"
              custom
              onChange={(e) => {
                let gender = e.target.value;
                setInfo({ ...info, gender: gender });
              }}
            >
              <option value="">성별</option>
              <option value="M">남자</option>
              <option value="F">여자</option>
            </Form.Control>
          </Col>
          <Col>
            <Button type="submit" className="bg-custom-color"
              style={{ border: 'none' }}>검색</Button>
          </Col>
        </Row>
      </Form>
      <Table bordered className="text-center" style={{ minWidth: '700px' }}>
        <thead>
          <tr style={{ color: 'white' }} className="bg-custom-color">
            <th>종합순위</th>
            <th>이름</th>
            <th>배번호</th>
            <th>성별</th>
            <th>출발시간</th>
            <th>완주시간</th>
            <th>소요시간</th>
          </tr>
        </thead>
        <tbody>
          {
            result.map((item, key) => {
              return (
                <tr>
                  <td>{item.totalRank}</td>
                  <td style={{ overflow: 'hidden' }}>{item.runnerName}</td>
                  <td>{item.backNo}</td>
                  <td>{item.gender === 'M' ? '남자' : '여자'}</td>
                  <td>{(item.startTime + '').split('T')[1]}</td>
                  <td>{(item.finishTime + '').split('T')[1]}</td>
                  <td>{item.elapseTime}</td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
    </Container>
  );
};

export default UntactRank;
